<template>
	<div class="c-variant-selector">
		<div class="c-variant-selector__controls">

			<template v-if="variants.length > 1">
				<div class="c-variant-selector__control c-variant-selector__control--variants" v-for="option in options">

					<label class="c-variant-selector__control-name">{{ option.name }}:</label>

					<div class="c-variant-selector__choices c-variant-selector__choices--select-wrapper">
						<select class="c-variant-selector__select" :name="option.name" :id="option.name" v-model="optionModels[option.name]">
							<option v-for="value in option.values" :value="value">{{ value }}</option>
						</select>
						<svg class="icon icon-arrow"><use xlink:href="#icon-arrow"></use></svg>
					</div>
				</div>
			</template>


			<div class="c-variant-selector__control c-variant-selector__control--quantity">

				<label class="c-variant-selector__control-name" for="quantity">Quantity:</label>

				<div class="c-variant-selector__choices c-variant-selector__choices--select-wrapper">
					<select class="c-variant-selector__select" name="quantity" id="quantity" v-model="quantity">
						<option v-for="quantity in selectedQuantity" :value="quantity">{{ quantity }}</option>
					</select>
					<svg class="icon icon-arrow"><use xlink:href="#icon-arrow"></use></svg>
				</div>
			</div>

		</div>


		<button
			class="c-variant-selector__button c-button c-button--add-to-cart"
			type="button"
			@click="addToCart"
			:disabled="!selectedQuantity||buttonDisabled"
		>
			<span class="c-button__text">{{ buttonText }}</span>
			<span class="c-button__price">{{ selectedPrice }}</span>
		</button>
	</div>
</template>

<script>
export default {
	name: 'VariantSelector',
	props: {
		options: Object,
		variants: Object,
		settings: Object,
	},
	data() {
		return {
			optionModels: {},
			quantity: 1,
		};
	},
	computed: {
		selectedVariant() {
			return this.variants.find((variant) => {
				return variant.node.selectedOptions.every((option) => {
					return this.optionModels[option.name] == option.value;
				});
			});
		},
		selectedQuantity() {
			return this.selectedVariant.node.quantityAvailable;
		},
		selectedPrice() {

			const price = this.selectedVariant.node.price;
			const locale = document.documentElement.lang ?? 'en-US';

			return new Intl.NumberFormat(locale, { style: 'currency', currency: price.currencyCode }).format(
				parseFloat(price.amount) * this.quantity
			);
		},
		buttonText() {
			if (this.settings.buttonTitle) {
				return this.settings.buttonTitle;
			}

			return 'Add to cart';
		},
		buttonDisabled() {
			if (this.settings.buttonDisabled) {
				return this.settings.buttonDisabled;
			}

			return false;
		}
	},
	watch: {
		selectedVariant() {
			if (!this.quantity && this.selectedQuantity > 0) {
				this.quantity = 1;
				return;
			}

			if (this.quantity > this.selectedQuantity) {
				this.quantity = this.selectedQuantity;
				return;
			}
		},
	},
	created() {
		this.options.forEach((option) => {
			this.optionModels[option.name] = option.values[0];
		});
	},
	methods: {
		addToCart() {
			wp.hooks.doAction('do.addToCart', {
				lines: [
					{
						quantity: this.quantity,
						merchandiseId: this.selectedVariant.node.id,
					},
				],
				extras: {
					openCartAfterAdding: true,
				},
			});
		},
	},
};
</script>

<style lang="scss" scoped></style>
